/**
 * Admin registration notification constants (main app).
 * Mirror: backend/src/config/adminRegistrationNotify.ts, functions/src/adminRegistrationNotify.ts
 */

export const ADMIN_REGISTRATION_NOTIFY_DEFER = {
  CLOUD_RUN: 'cloud_run',
  FIREBASE_FUNCTION: 'firebase_function',
} as const;

export const ADMIN_REGISTRATION_NOTIFY_KIND = {
  SKIP_REJECTED: 'skip_rejected',
  MANUAL_APPROVAL_REQUIRED: 'manual_approval_required',
  AUTHORITY_VERIFIED_AWAITING_ONBOARDING: 'authority_verified_awaiting_onboarding',
  AUTHORITY_CHECK_DISABLED_PENDING: 'authority_check_disabled_pending',
  TEAM_MEMBER_JOINED: 'team_member_joined',
} as const;

export const REGISTRATION_SOURCE_REGISTER_WITH_AUTHORITY = 'register_with_authority' as const;

/** Mirror: backend/src/config/passportConstants.ts PASSPORT_REGISTRATION_SOURCE_TRANSPORT */
export const PASSPORT_REGISTRATION_SOURCE_TRANSPORT = 'passport_transport' as const;
